import api from "@/services/EventService.js";

const state = {
  studente: [],
  isAuth: false,
};

const getters = {
  isAuthenticated: (state) => state.isAuth,

  Studente: (state) => state.studente,
};

const actions = {
  async LogIn(rootState, datiLogin) {
    //var datistudente =[];
    //alert(JSON.stringify(rootState.rootState.parametri))
    //rootState.rootState.parametri.prematricola = 17849;
    //alert("chiamato" + JSON.stringify(datiLogin));

    try {
      const response = await api.post("/login/immatricolazioni", datiLogin);
      //alert("Risposta API login:" + JSON.stringify(response));
      return response; // Restituzione diretta del risultato positivo
    } catch (error) {
      //alert("Errore autenticazione:" + JSON.stringify(error));

      // Invece di risolvere con un oggetto errore, creiamo una risposta simulata
      // che ha la stessa struttura di una risposta Axios
      return {
        status: 401,
        data: {
          message: "Credenziali non valide",
          error: error.message,
        },
        headers: {},
        config: {},
        statusText: "Unauthorized",
      };
    }

    /*return await api
      .post("/login/immatricolazioni", datiLogin)
      .then((r) => {
        alert("log:" + JSON.stringify(r));
        return r;
      })
      .catch((error) => {
        alert("errore autenticazione");
        return {
          status: 401,
          data: { message: error },
        };
      });*/

    //await commit('setUser')
  },
  async LogInSegreteria(rootState, datiLogin) {
    //var datistudente =[];
    //alert(JSON.stringify(rootState.rootState.parametri))
    //rootState.rootState.parametri.prematricola = 17849;
    //alert("chiamato" + JSON.stringify(datiLogin))
    let risposta = null;
    await api
      .post("/login/immatricolazioni/segreteria", datiLogin, {
        validateStatus: () => true,
      })
      .then((r) => {
        //alert("log:" + JSON.stringify(r))
        risposta = r;
      })
      .catch((err) => {
        //alert("errore:"+JSON.stringify(err))
        risposta = err.response;
        //return (err);
        //throw err;
      });
    return risposta;
    //await commit('setUser')
  },
  async LogOut({ commit }) {
    await commit("logout");
  },
};

const mutations = {
  setUser(rootState) {
    alert("set");
    rootState.parametri.prematricola = 1234;
  },
  logout(state) {
    state.studente = null;
    state.isAuth = false;
    // Rimuoviamo il token JWT dal localStorage al logout
    localStorage.removeItem("jwt_token");
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
